$(document).ready(function() {
	// -- fix fancybox cross origin --
	$.fancybox.defaults.hash = false;
	
	// -- default --
	$('[data-fancybox]').fancybox({
		loop: false,
		buttons : [
			'close'
		],
    type: 'image',
    autoScale: true,
    autoDimensions: true,
		animationEffect : 'fade',
	});
	
		
	// $('.fancyWall').fancybox({
	// 	'loop': false,
	// });
	
	// $('.fancyGallery').fancybox({
	// 	'loop': false,
	// });
	
	// $('.fancyEvent').fancybox({
	// 	'loop': false,
	// });
	
});